var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.01851 1.72656C4.54256 1.72656 2.53041 3.73872 2.53041 6.21464V8.37639C2.53041 8.83267 2.33593 9.52833 2.10404 9.91729L1.24383 11.346C0.712738 12.2287 1.07926 13.2085 2.05168 13.5377C5.27561 14.6148 8.7539 14.6148 11.9778 13.5377C12.8829 13.2385 13.2794 12.1688 12.7857 11.346L11.9255 9.91729C11.7011 9.52833 11.5066 8.83267 11.5066 8.37639V6.21464C11.5066 3.7462 9.48695 1.72656 7.01851 1.72656Z",
    stroke: "#0A7F8F",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.40241 1.9425C8.17053 1.87517 7.93116 1.82281 7.68432 1.79289C6.96623 1.70313 6.27806 1.75549 5.63477 1.9425C5.85169 1.38897 6.39026 1 7.01859 1C7.64692 1 8.18549 1.38897 8.40241 1.9425Z",
    stroke: "#0A7F8F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.26247 13.8047C9.26247 15.0389 8.25266 16.0487 7.01844 16.0487C6.40507 16.0487 5.83658 15.7944 5.43267 15.3905C5.02874 14.9865 4.77441 14.4181 4.77441 13.8047",
    stroke: "#0A7F8F",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification_active.0dc6c26902eae70434ff1e796aeea014.svg";
export { ForwardRef as ReactComponent };